import React from 'react';

import PropTypes from 'prop-types';

import { PromoText } from 'components/no-auth/common/PromoText/PromoText';

import { DateContainer } from './styles';

export const DateAndLocation = (props) => {
    return (
        <>
            {props.date && (
                <DateContainer>
                    <PromoText color={'gray40'} variant={props.textVariant}>
                        {props.date}
                    </PromoText>
                </DateContainer>
            )}
        </>
    );
};

DateAndLocation.propTypes = {
    textVariant: PropTypes.oneOf(['span', 'subheader']),
    date: PropTypes.string,
};
